module.exports = __webpack_public_path__ + "static/media/slim-prata.14a831ac.webp";